/** @param {*} id */
export function normalizeFileinfoId(id) {
  if (id == null || id === "") return null;
  return String(id);
}

/** Coerce to unique non-empty string ids (FileInfo ids may arrive as numbers from the API). */
export function normalizeFileinfoIdList(ids) {
  if (!ids?.length) return undefined;
  const out = [];
  const seen = new Set();
  for (const id of ids) {
    const s = normalizeFileinfoId(id);
    if (s && !seen.has(s)) {
      seen.add(s);
      out.push(s);
    }
  }
  return out.length ? out : undefined;
}

const FILE_INFO_SPEC_ID_LIST_KEYS = [
  "prefer_fileinfo_ids",
  "other_fileinfo_ids",
  "exclude_fileinfo_ids",
  "round_ids",
  "question_ids",
  // Foundation Data v2 reporting years. Not ids of anything indexed, but they normalise the same way, and
  // the AI service's own normalisation loop covers this key too - the two lists should not disagree about
  // which fields are id-lists.
  "foundation_year_ids",
];

/** @param {import("api/ai/ai.service").FileInfoSpec?} spec */
export function normalizeFileInfoSpec(spec) {
  if (!spec) return spec;
  const out = { ...spec };
  for (const key of FILE_INFO_SPEC_ID_LIST_KEYS) {
    if (out[key] != null) {
      out[key] = normalizeFileinfoIdList(out[key]);
    }
  }
  if (out.folder_id != null) {
    out.folder_id = String(out.folder_id);
  }
  return out;
}

/** @param {*} fileInfo */
export function normalizeFileInfo(fileInfo) {
  if (!fileInfo) return fileInfo;
  const id = normalizeFileinfoId(fileInfo.id);
  if (!id) return fileInfo;
  return fileInfo.id === id ? fileInfo : { ...fileInfo, id };
}

/** paranoia (ids should be normalized to strings already) Dedupe by string id; coerce each FileInfo.id to string. */
export function normalizeFileInfoList(fileInfos) {
  if (!fileInfos?.length) return fileInfos;
  const out = [];
  const seen = new Set();
  for (const f of fileInfos) {
    const n = normalizeFileInfo(f);
    if (!n?.id || seen.has(n.id)) continue;
    seen.add(n.id);
    out.push(n);
  }
  return out;
}

/** paranoia for numbers/strings equality */
export function fileinfoIdEquals(a, b) {
  if (a == null || b == null) return a === b;
  if (typeof a === "number" && typeof b === "number") {
	console.warn("fileinfoIdEquals - comparing numbers - should have been normalized", a, b);
  }
  return String(a) === String(b);
}

/** IssbQuestion.files: string/number ids or FileInfo-shaped objects → prefer_fileinfo_ids strings. */
export function preferIdsFromQuestionFiles(files) {
  if (!files?.length) return [];
  const first = files[0];
  if (typeof first === "string" || typeof first === "number") {
    return normalizeFileinfoIdList(files) || [];
  }
  return normalizeFileinfoIdList(files.map((f) => f?.id)) || [];
}
